import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { UiButtonComponent } from '../../atoms/button/button.component';
import { UiPromotionCard } from './promotion-card.types';

export type { UiPromotionCard } from './promotion-card.types';

const MAX_PROJECTS = 6;

/**
 * Organismo: ficha de promoción del portal.
 *
 * Muestra imagen, título, vigencia, descripción, acción de detalle y hasta
 * 6 proyectos donde aplica. Es presentacional: no navega ni conoce API.
 */
@Component({
  selector: 'ui-promotion-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiButtonComponent],
  templateUrl: './promotion-card.component.html',
  styleUrl: './promotion-card.component.scss',
  host: {
    class: 'ui-promotion-card-host',
    '[class.ui-promotion-card-host--mobile-flat]': 'mobileFlat()',
  },
})
export class UiPromotionCardComponent {
  readonly promotion = input.required<UiPromotionCard>();
  readonly validityLabel = input('Vigencia');
  readonly projectsLabel = input('Proyectos');
  readonly detailsLabel = input('Ver detalles de promoción');
  readonly mobileFlat = input(false);

  readonly detailsClick = output<void>();

  protected readonly visibleProjects = computed(() =>
    this.promotion().projects.slice(0, MAX_PROJECTS),
  );
}
